// @todo: Migrate to 'TextField' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {TextField} from '@material-ui/core';
// @todo: Migrate to 'Button' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {WBButton} from '@wandb/weave/common/components/elements/WBButtonNew';
import * as globals from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled, {css} from 'styled-components';

export const Container = styled.div<{selected: boolean}>`
  ${p =>
    p.selected &&
    css`
      box-shadow: 0 0 0 6px rgb(208, 225, 252);
    `}
`;

export const EditContainer = styled.div`
  background-color: ${globals.GRAY_TRANSPARENT};
  padding: 24px;
  margin-bottom: 24px;
`;

export const EditMessage = styled.div<{marginTop?: boolean}>`
  font-style: italic;
  margin-bottom: 24px;
  ${p =>
    p.marginTop &&
    css`
      margin-top: 24px;
    `}
`;

export const EditInputContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
`;

export const EditTextField = styled(TextField)`
  flex-grow: 1;
`;

export const SubmitButton = styled(WBButton).attrs({variant: `confirm`})<{
  marginLeft?: boolean;
  marginTop?: boolean;
}>`
  &&& {
    ${p =>
      p.marginLeft &&
      css`
        margin-left: 16px;
      `}

    ${p =>
      p.marginTop &&
      css`
        margin-top: 16px;
      `}
  }
`;
